import { Helper } from '../../../js/util/helper';

export default class Search {
  constructor( node ) {
    this.node = node;
    this.searchForm = node.querySelector( '.js-search-search-form' );
    this.searchInput = node.querySelector( '.js-search-search-input' );
    this.searchInputLabel = node.querySelector( '.search__search-input-label' );
    this.searchSubmit = node.querySelector( '.js-search-search-submit' );
    this.searchAutoSuggest = node.querySelector( '.search__search-autosuggest-container' );
    this.searchReset = node.querySelector( '.search__search-reset' );

    this.addEventListener();
    this.initSearch();

    window.onload = () => {
      this.handleLabel( this.searchInput );
    };

    this.handleFocus();
  }
  addEventListener() {
    this.searchSubmit.addEventListener( 'click', () => {
      this.searchForm.submit();
    });
  }
  initSearch() {
    this.searchInput.onfocus = function() {
      if ( !this.searchInputLabel.classList.contains( 'search__search-input-label--active' )) {
        this.searchInputLabel.classList.add( 'search__search-input-label--active' );
      }
    }.bind( this );

    this.searchInput.onblur = function() {
      if ( this.searchInputLabel.classList.contains( 'search__search-input-label--active' ) && this.searchInput.value === '' ) {
        this.searchInputLabel.classList.remove( 'search__search-input-label--active' );
      }
    }.bind( this );

    this.searchReset.addEventListener( 'click', () => {
      this.searchInput.value = '';
    });

    this.searchInput.addEventListener( 'input', ( e ) => {
      let input = e.target.value;

      if ( input.length >= 3 ) {
        this.requestAutoSuggest( input );
      } else if ( input.length < 3 && this.searchAutoSuggest.classList.contains( 'search__search-autosuggest-container--active' )) {
        this.searchAutoSuggest.classList.remove( 'search__search-autosuggest-container--active' );
        this.searchAutoSuggest.children[ 0 ].innerHTML = '';
      }
    });
  }
  requestAutoSuggest( input ) {
    let xmlhttp = new XMLHttpRequest();

    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
      if ( xmlhttp.readyState === 4 && xmlhttp.status === 200 ) {
        let response = xmlhttp.responseText;
        let json = JSON.parse( response.replace( /<\/?[^>]+>/gi, '' ));
        this.fillAutoSuggest( json, input );
      }
    }.bind( this );
    xmlhttp.open( 'GET', `search_api_autocomplete/search?display=search_page&filter=query&q=${ input }`, true );
    xmlhttp.send();

    // this.fillAutoSuggest([ { value: 'slider' }, { value: 'slide' }, { value: 'slider container' }, { value: 'slider machine' }, { value: 'slideshow' }, { value: 'sliderview' }, { value: 'slider' }, { value: 'slider' } ], input );
  }
  fillAutoSuggest( data, input ) {
    let result = '';

    if ( data.length > 0 ) {
      for ( let string of data ) {
        let temp = string.value.split( input );
        if ( temp.length > 1 ) {
          let html = this.createResultAsHtml( temp, input );
          result = result +
            `<li class="search__search-autosuggest-item" data-input="${string.value}" tabindex="0">
                <span class="search__search-autosuggest-result">${ html }</span>
             </li>`;
        }
      }
      if ( result !== '' ) {
        this.searchAutoSuggest.children[ 0 ].innerHTML = result;
        this.autoSuggestClickEvent();
        if ( !this.searchAutoSuggest.classList.contains( 'search__search-autosuggest-container--active' )) {
          this.searchAutoSuggest.classList.add( 'search__search-autosuggest-container--active' );
        }
      }
    }
  }
  createResultAsHtml( array, input ) {
    let result = '';
    for ( let i = 0; i < array.length; i++ ) {
      if ( array[ i ] === '' && i === 0 ) {
        result = result +
          '<span class="search__search-autosuggest-result search__search-autosuggest-input">' + input + '</span>';
      } else if ( i !== array.length - 1 ) {
        result = result + array[ i ] +
          '<span class="search__search-autosuggest-result search__search-autosuggest-input">' + input + '</span>';
      } else {
        result = result + array[ i ];
      }
    }
    return result;
  }
  autoSuggestClickEvent() {
    let items = document.querySelectorAll( '.search__search-autosuggest-item' );
    let search = this.node.querySelector( '#search-search-input' );

    for ( let item of items ) {
      item.addEventListener( 'click', () => {
        search.value = item.getAttribute( 'data-input' );
        document.getElementById( 'search-search-submit' ).click();
      });
      item.onkeydown = function( e ) {
        if ( e.keyCode === 13 || e.keyCode === 32 ) {
          search.value = item.getAttribute( 'data-input' );
          document.getElementById( 'search-search-submit' ).click();
        }
      };
    }
  }
  handleLabel( input ) {
    if ( input.value.trim() !== '' ) {
      this.searchInputLabel.classList.add( 'search__search-input-label--active' );
    } else if ( input.value.trim() === '' && this.searchInputLabel.classList.contains( 'search__search-input-label--active' )) {
      this.searchInputLabel.classList.remove( 'search__search-input-label--active' );
    }
  }
  handleFocus() {
    this.searchInput.onfocus = function() {
      document.onkeydown = function( e ) {
        setTimeout( function() {
          let itemsContainer = this.searchAutoSuggest.querySelector( '.search__search-autosuggest-items' );
          if ( itemsContainer.children.length > 0 ) {
            let active = this.searchAutoSuggest.querySelector( '.search__search-autosuggest-item--active' );

            if ( active === null && ( e.keyCode === 40 || e.keyCode === 38 )) {
              itemsContainer.children[ 0 ].classList.add( 'search__search-autosuggest-item--active' );
            } else if ( active !== null && e.keyCode === 40 ) {
              for ( let i = 0; i < itemsContainer.children.length; i++ ) {
                if ( itemsContainer.children[ i ].classList.contains( 'search__search-autosuggest-item--active' ) && i !== itemsContainer.children.length - 1 ) {
                  active.classList.remove( 'search__search-autosuggest-item--active' );
                  itemsContainer.children[ i + 1 ].classList.add( 'search__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ i + 1 ].offsetHeight * ( i + 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                } else if ( itemsContainer.children[ i ].classList.contains( 'search__search-autosuggest-item--active' ) && i === itemsContainer.children.length - 1 ) {
                  active.classList.remove( 'search__search-autosuggest-item--active' );
                  itemsContainer.children[ 0 ].classList.add( 'search__search-autosuggest-item--active' );
                  let toScroll = 0;
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                }
              }
            } else if ( active !== null && e.keyCode === 38 ) {
              for ( let i = 0; i < itemsContainer.children.length; i++ ) {
                if ( itemsContainer.children[ i ].classList.contains( 'search__search-autosuggest-item--active' ) && i !== 0 ) {
                  active.classList.remove( 'search__search-autosuggest-item--active' );
                  itemsContainer.children[ i - 1 ].classList.add( 'search__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ i - 1 ].offsetHeight * ( i - 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                } else if ( itemsContainer.children[ i ].classList.contains( 'search__search-autosuggest-item--active' ) && i === 0 ) {
                  active.classList.remove( 'search__search-autosuggest-item--active' );
                  itemsContainer.children[ itemsContainer.children.length - 1 ].classList.add( 'search__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ itemsContainer.children.length - 1 ].offsetHeight * ( itemsContainer.children.length - 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                }
              }
            } else if ( active !== null && ( e.keyCode === 13 || e.keyCode === 32 )) {
              let search = this.node.querySelector( '#search-search-input' );
              search.value = active.getAttribute( 'data-input' );
              document.getElementById( 'search-search-submit' ).click();
            }
          }
        }.bind( this ), 0 );
      }.bind( this );
    }.bind( this );
  }
}

